import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../../../../core/layout/Breadcrumb';

const MasteryTestItemHistoryBreadcrumbs = (props) => (
  <Breadcrumb
    fetching={props.fetching}
    crumbs={[
      {
        text: `Course - ${props.masteryTestItem.masteryTest.module.course.name}`,
        link: '/modules',
      },
      {
        text: `Module - ${props.masteryTestItem.masteryTest.module.name}`,
        link: `/modules/${props.masteryTestItem.masteryTest.module.id}/details`,
      },
      {
        text: 'Mastery Test Items',
        link: `/modules/${props.masteryTestItem.masteryTest.module.id}/mastery-tests/${props.masteryTestItem.masteryTest.id}`,
      },
      {
        text: 'History',
      },
    ]}
  />
);

MasteryTestItemHistoryBreadcrumbs.propTypes = {
  fetching: PropTypes.bool,
  masteryTestItem: PropTypes.shape({
    masteryTest: PropTypes.shape({
      id: PropTypes.string.isRequired,
      modulePercentageToActive: PropTypes.number.isRequired,
      module: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        course: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

MasteryTestItemHistoryBreadcrumbs.defaultProps = {
  fetching: false,
};

export default MasteryTestItemHistoryBreadcrumbs;
